<template>
  <!-- Control-level gate: when every configured link is unreachable the whole
       panel renders nothing (no dead widgets); the editor always shows it. -->
  <div v-if="editMode || links.length" class="v3-widget v3-panel v3-panel-pad" style="padding-bottom: 0" v-testid="testid">
    <div class="v3-panel-head" style="padding: 0 0 6px"><h3 v-testid="testid + '-title'">{{ heading }}</h3></div>
    <div class="v3-links">
      <button v-for="(l, i) in links" :key="i" class="v3-link" type="button" v-testid="testid + '-row-' + (l.destination || l.url || l.label)" @click="go(l)">
        <span class="ms">{{ l.icon || 'chevron_right' }}</span>{{ l.label }}<span class="ms chev">chevron_right</span>
      </button>
    </div>
  </div>
</template>

<script>
import { canNavigateTo } from "@/composables/useV3Nav";

// New-portal (v3) LinkList — the prototype V3QuickLinks "Go to" LIST (icon ·
// label · chevron rows), distinct from the QuickLinks tile grid (V3LinkTiles).
// Pure presentation. Sibling: rm-portal-beta LinkListWidget.vue.
export default {
  name: "cLandingV3LinkList",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3LinkList";
    },
    heading() {
      return this.definition.heading || this.definition.title || "Go to";
    },
    // Legacy-landing-config parity: only surface links the user can reach
    // (route permission gate); the editor shows everything.
    links() {
      const all = Array.isArray(this.definition.links) ? this.definition.links : [];
      if (this.editMode) return all;
      return all.filter((l) => {
        const dest = l.destination || l.url;
        return !dest || canNavigateTo(this, dest);
      });
    },
  },
  methods: {
    go(l) {
      if (this.editMode) return;
      const dest = l.destination || l.url;
      if (!dest) return;
      if (/^https?:\/\//i.test(dest)) {
        window.open(dest, "_blank");
        return;
      }
      this.$router.push({ name: dest }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
